import React from 'react';
import styled from 'styled-components';

export const StyledHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 5px 14px 0;
`;


const Header = ({ children }) => {
  return (
    <StyledHeader>
      {children}
    </StyledHeader>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Header/Header.jsx